import { Api } from 'API/MPWApi';
import { CANCEL_REQUEST } from 'State/types';

/**
 * Custom Redux Thunk Implementation used for MPWWebApi override
 * @param {Any} extraArgument
 */
export function createThunkMiddleware(extraArgument) {
  return ({ dispatch, getState }) => next => action => {
    if (typeof action === 'function') {
      if (action.USER && action.USER.Token) {
        const API = new Api();
        API.setToken(action.USER.Token);
        return action(dispatch, getState, API);
      }
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
}

export function createRequestCancelationMiddleware() {
  const sources = {};

  return ({ dispatch, getState }) => next => action => {
    const { type, payload, cancelable, source } = action;

    if (!cancelable) {
      return next(action);
    }
    /**
     * request started and is cancelable
     */
    if (cancelable && payload) {
      // there is a current cancel token for that request
      if (sources[type]) {
        sources[type].cancel();
        delete sources[type];
      }
      sources[type] = source;
    }

    if (type === CANCEL_REQUEST) {
      const cancelRequestType = payload;
      if (sources[cancelRequestType]) {
        sources[cancelRequestType].cancel();
        delete sources[cancelRequestType];
      }
    }
    return next(action);
  };
}



// WEBPACK FOOTER //
// ./src/common/Middleware/index.js